import { apiType } from "./apiType";
import { IApplicantHistoryResponse } from "@/src/types/applicant";

export interface IApplicantHistoryCreatePayload {
  text: string;
  applicant_id: number;
}

export const applicantHistoryRequests = {
  create: async (payload: IApplicantHistoryCreatePayload) => {
    try {
      return await apiType.main.post<IApplicantHistoryResponse>(`/applicant/history/create`, payload);
    } catch (error) {
      console.log("This is applicantHistory create error:", error);
      return null;
    }
  },
  list: async (applicantId: number) => {
    try {
      return await apiType.main.get<IApplicantHistoryResponse[]>(`/applicant/history/list`, {
        applicant_id: applicantId,
      });
    } catch (error) {
      console.log("This is applicantHistory list error:", error);
      return null;
    }
  },
  getByApplicantId: async (applicantId: number) => {
    try {
      return await apiType.main.get<IApplicantHistoryResponse[]>(`/applicant/history/${applicantId}`);
    } catch (error) {
      console.log("This is applicantHistory getByApplicantId error:", error);
      return null;
    }
  },
};
